import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  basketBadge: {
    backgroundColor: "white",
    color: "#1E49E2",
    fontSize: "10px",
    minWidth: "6px",
    height: "14px",
    fontWeight: "bold",
    padding: "4px",
  },
  basket: {
    marginRight: "10px",
    marginLeft: "auto",
    padding: "0px",
    borderRight: ".5px solid",
    borderRadius: "0px",
    cursor: "pointer",
    color: "white",
    [theme.breakpoints.down('md')]: {
      margin: "0",
      padding: "0px 5px 0px 30px",
      width: "20%",
    },
    [theme.breakpoints.down(700)]: { display: "none" },
    "&:hover": {
      outline: "2px solid white",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid white",
    },
  },
  basketBadgeMobile: {
    backgroundColor: "#eb004d",
    color: "white",
    margin: "0px",
    marginRight: "13px",
    padding: "0px !important",
    fontSize: "10px",
    minWidth: "12px",
    height: "12px",
  },
  basketMobile: {
    textTransform: "none",
    textDecoration: "none",
    padding: "0px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  anchorTopRight: {
    transform: "translate(35%, -35%)",
    height: "17px",
  },
}));
